import { Component, OnInit, Inject, HostListener } from "@angular/core";
import { MatDialog, MatSnackBar } from "@angular/material";
import { SessionService } from "../shared/services/session.service";
import { BackendApiService } from "../shared/services/backend-api.service";
import { DOCUMENT } from "@angular/platform-browser";
import { environment } from "../../environments/environment.prod";
import { LoginComponent } from "../login/login.component";
import { PrivacyComponent } from "../privacy/privacy.component";
import { VideoJsComponent } from "../video-js/video-js.component";
import { TAndCComponent } from "../t-and-c/t-and-c.component";
import { RegistrationComponent } from "../registration/registration.component";
import { NgForm } from "@angular/forms";
import { User } from "../shared/class/user";
import { MessageserviceService } from "../shared/services/messageservice.service";
import { Subscription } from "rxjs/Subscription";
import { MedialistComponent } from "../medialist/medialist.component";

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.css"],
})
export class HomePageComponent implements OnInit {
  im: number;
  bannerImage: string;
  i: number;
  tid: any;
  imageSources: string[];
  scroll: any;
  userActivePackage: any;
  packageList: any[];
  guestEmail: any;
  subject: any;
  guestMobile: any;
  guestMessage: any;
  guestName: any;
  id: number = 1;
  user: User = new User();
  collapse: boolean = false;
  subscription: Subscription;
  message: any;

  constructor(
    public dialog: MatDialog,
    private sessionService: SessionService,
    private backendApiService: BackendApiService,
    private snackBar: MatSnackBar,
    @Inject(DOCUMENT) private document: Document,
    private messageservice: MessageserviceService
  ) {
    this.imageSources = ["assets/images/anandtv_banner.jpg"];
    this.subscription = this.messageservice
      .getMessage()
      .subscribe((message) => {
        this.user = this.sessionService.getData();
      });
  }

  openpayment(data) {
    if (this.sessionService.isData()) {
      this.user = this.sessionService.getData();
      window.location.href =
        environment.apiUrl.baseUrl +
        "paytabPayPage?userId=" +
        this.user.id +
        "&countryISOCode=" +
        this.user.countryISOCode +
        "&deviceId=" +
        this.user.deviceId +
        "&packTypeStatus=1&deviceType=6&mediaId=" +
        data.id;
      // const dialogRef = this.dialog.open(PaymentComponent);
      //
      //     dialogRef.afterClosed().subscribe(result => {
      //       console.log(`Dialog result: ${result}`);
      //     });
      //     dialogRef.componentInstance.packageData = data;
    } else {
      this.openDialog();
    }
  }

  changeBanner() {
    this.im = this.i;

    // this.im=this.im+1;
    if (this.im >= this.imageSources.length) {
      this.im = 0;
    }
    console.log(this.im);
    this.bannerImage = this.imageSources[this.im];
  }

  openDialog() {
    const dialogRef = this.dialog.open(LoginComponent, {});

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }
  openPrivacy() {
    const dialogRef = this.dialog.open(PrivacyComponent, {
      height: "350px",
    });
  }
  openVideoJS() {
    const videoDailog = this.dialog.open(VideoJsComponent, {});

    videoDailog.afterClosed().subscribe((result) => {
      console.log(`Dialog  result: ${result}`);
    });
  }
  openTandC() {
    this.dialog.open(TAndCComponent, {
      height: "100%",
    });
  }
  openDialogSignUp() {
    const dialogRef = this.dialog.open(RegistrationComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  collapseFun(id) {
    this.collapse = false;
    this.id = id;
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    console.log(document.documentElement.scrollTop);
    let x = window.matchMedia("(max-width: 767px)");
    let medium_device = window.matchMedia("(max-width: 1440px)");
    if (!x.matches) {
      if (medium_device.matches) {
        let pos: number = document.documentElement.scrollTop;
        if (pos > 0 && pos < 582) {
          this.id = 1;
        }
        if (pos > 582 && pos < 1320) {
          this.id = 2;
        }
        if (pos > 1320 && pos < 1849) {
          this.id = 3;
        }
        if (pos > 1849 && pos < 2591) {
          this.id = 4;
        }
        if (pos > 2591 && pos < 3414) {
          this.id = 5;
        }
        if (pos > 3414 && pos < 4239) {
          this.id = 6;
        }
      } else {
        let pos: number = document.documentElement.scrollTop;
        if (pos > 0 && pos < 864) {
          this.id = 1;
        }
        if (pos > 864 && pos < 1394) {
          this.id = 2;
        }
        if (pos > 1394 && pos < 2013) {
          this.id = 3;
        }
        if (pos > 2013 && pos < 2736) {
          this.id = 4;
        }
        if (pos > 2736 && pos < 3603) {
          this.id = 5;
        }
        if (pos > 3603 && pos < 4239) {
          this.id = 6;
        }
      }
    }
  }

  sendContactUs(isValid: NgForm) {
    if (isValid.valid) {
      const requestData = {
        name: this.guestName,
        email: this.guestEmail,
        subject: this.subject,
        phone: this.guestMobile,
        message: this.guestMessage,
      };

      this.backendApiService
        .postRawRequest("get_in_touch", requestData)
        .subscribe(
          (response: any) => {
            if (response.responseCode === "SC101") {
              isValid.resetForm();

              this.snackBar.open("Thanks for your valuable message.", "", {
                duration: 3000,
              });
            } else if (response.responseCode === "FC101") {
              this.snackBar.open("Something went wrong", "close", {
                duration: 2000,
              });
            } else {
              this.snackBar.open("", "close", {
                duration: 3000,
              });
            }
          },
          (error) => {
            this.snackBar.open(
              new DOMParser()
                .parseFromString(error.error, "text/html")
                .getElementsByTagName("p")[1]
                .textContent.replace("Message", ""),
              "",
              {
                duration: 2000,
                verticalPosition: "top",
                horizontalPosition: "center",
                direction: "ltr",
              }
            );
          }
        );
    }
  }

  clearContactUS() {
    (this.guestName = ""),
      (this.guestEmail = ""),
      (this.subject = ""),
      (this.guestMobile = ""),
      (this.guestMessage = "");
  }

  getPackageList() {
    const requestData = {
      userId: this.user.id,
      deviceTypes: "6",
    };
    this.packageList = [];
    this.backendApiService
      .postRawRequest("getPackageDetails", requestData)
      .subscribe(
        (response: any) => {
          if (response.responseCode === "SC101") {
            console.log(response);
            this.packageList = response.packageDetails;
            this.userActivePackage = response.activepackages;
            this.packageList.forEach(function (item) {
              item.active = response.activepackages.includes(item.id);
              if (item.packName.toUpperCase().includes("SPECIAL")) {
                item.channelTag = "Special Channels";
              } else {
                item.channelTag = "All Channels";
              }
            });
          } else if (response.responseCode === "FC101") {
            this.snackBar.open("Something went wrong", "close", {
              duration: 2000,
            });
          } else {
            this.snackBar.open("Oops!!!! . Something went wrong", "close", {
              duration: 3000,
            });
          }
        },
        (error) => {
          this.snackBar.open(
            new DOMParser()
              .parseFromString(error.error, "text/html")
              .getElementsByTagName("p")[1]
              .textContent.replace("Message", ""),
            "",
            {
              duration: 2000,
              verticalPosition: "top",
              horizontalPosition: "center",
              direction: "ltr",
            }
          );
        }
      );
  }

  initiatePayment(packageObj: any) {
    console.log(packageObj);
    const requestData =
      "operationCodeConstant=OP1079&" +
      "userId=" +
      this.user.id +
      "&amount=" +
      packageObj.price +
      "&deviceType=" +
      6 +
      "&deviceId=" +
      this.user.deviceId +
      "&packTypeStatus=" +
      1 +
      "&mediaId=" +
      packageObj.id +
      "&gatewayId=" +
      2; // Paypal

    this.backendApiService.httpPostRequest("payment", requestData).subscribe(
      (response: any) => {
        if (response.responseCode === "SC101") {
          console.log(response);

          this.test(response.paypalModal);
        } else if (response.responseCode === "FC101") {
          this.snackBar.open("Something went wrong", "close", {
            duration: 2000,
          });
        } else {
          this.snackBar.open("Oops!!!! . Something went wrong", "close", {
            duration: 3000,
          });
        }
      },
      (error) => {
        this.snackBar.open(
          new DOMParser()
            .parseFromString(error.error, "text/html")
            .getElementsByTagName("p")[1]
            .textContent.replace("Message", ""),
          "",
          {
            duration: 2000,
            verticalPosition: "top",
            horizontalPosition: "center",
            direction: "ltr",
          }
        );
      }
    );
  }

  test(res) {
    const fd = new FormData();
    for (const key in res) {
      if (res.hasOwnProperty(key)) {
        fd.append(key, res[key]);
      }
    }

    fd.append("return", res.returnUrl);

    this.backendApiService.postFormData(res.purl, fd).subscribe(
      (response: any) => {
        console.log(response);
      },
      (error) => {
        this.snackBar.open(
          new DOMParser()
            .parseFromString(error.error, "text/html")
            .getElementsByTagName("p")[1]
            .textContent.replace("Message", ""),
          "",
          {
            duration: 2000,
            verticalPosition: "top",
            horizontalPosition: "center",
            direction: "ltr",
          }
        );
      }
    );
  }

  logOut() {
    if (this.sessionService.isData) {
      // const requestData = {
      //   userId: this.user.id,
      //   token: "this.sessionService.getUsertoken()",
      // };
      // this.backendApiService.postRawRequest("logoutweb", requestData).subscribe(
      //   (response: any) => {
          sessionStorage.clear();
          setTimeout(() => {
            location.reload();
          }, 1500);
      //   },
      //   (error) => {
      //     this.snackBar.open(
      //       new DOMParser()
      //         .parseFromString(error.error, "text/html")
      //         .getElementsByTagName("p")[1]
      //         .textContent.replace("Message", ""),
      //       "",
      //       {
      //         duration: 2000,
      //         verticalPosition: "top",
      //         horizontalPosition: "center",
      //         direction: "ltr",
      //       }
      //     );
      //   }
      // );
    }
  }

  openMediaListPopup(packid) {
    const dialogRef = this.dialog.open(MedialistComponent, {
      width: "460px",
    });
    dialogRef.componentInstance.packid = packid;
  }

  ngOnInit() {
    this.user = new User();
    if (this.sessionService.isData()) {
      this.user = this.sessionService.getData();
    }
    this.getPackageList();
    this.i = 0;
    this.bannerImage = this.imageSources[this.i];
    this.tid = setInterval(() => {
      if (this.i >= this.imageSources.length) {
        this.i = 0;
      }
      this.bannerImage = this.imageSources[this.i];
      this.i = this.i + 1;
    }, 4000);
  }
  ngOnDestroy() {
    if (this.tid) {
      clearInterval(this.tid);
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home-page/home-page.component.ts